module.exports = __webpack_public_path__ + "static/img/1-2-1.260bf1f8.jpg";